import { List } from 'foundations-components/transitional/components/List';
import { Tile, TileSection } from 'foundations-components/transitional/components/Tile';
import { SKELETON_VALUE_HEIGHT, SKELETON_VALUE_MARGIN_TOP, SkeletonValue } from './PropertySkeleton';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PRIMARY_SKELETON_VALUE_MARGIN_TOP = 4;
const LAST_SKELETON_VALUE_MARGIN_BOTTOM = 4;
const ITEM_MARGIN_HEIGHT = 16; // keep in sync with Tile's marginBlockStart
const TILE_MARGIN_BOTTOM = 12; // Keep in sync with Tile's marginBlockEnd
const TILE_PADDING = 16; // Keep in sync with Tile's paddingBlockStart
const TILE_BORDER = 2; // Keep in sync with Tile's borderWidth

export function getChicletListSkeletonHeight(loadingComponentProps) {
  const {
    numberOfSkeletons,
    numberOfProperties
  } = loadingComponentProps;
  const tileHt = TILE_PADDING + TILE_BORDER + PRIMARY_SKELETON_VALUE_MARGIN_TOP + (numberOfProperties + 1) * SKELETON_VALUE_HEIGHT + numberOfProperties * SKELETON_VALUE_MARGIN_TOP + LAST_SKELETON_VALUE_MARGIN_BOTTOM;
  const numSkeletonsNormalized = numberOfSkeletons > 5 ? 5 : numberOfSkeletons;
  const ht = numSkeletonsNormalized * tileHt + (numSkeletonsNormalized - 1) * Math.max(ITEM_MARGIN_HEIGHT, TILE_MARGIN_BOTTOM) + TILE_MARGIN_BOTTOM; /* margin bottom after last tile */
  return ht;
}
function ChicletContentSkeleton({
  cardId,
  numberOfProperties
}) {
  return /*#__PURE__*/_jsx(List, {
    styled: false,
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(SkeletonValue, {
        "data-test-id": "chiclet-skeleton-value",
        marginTop: PRIMARY_SKELETON_VALUE_MARGIN_TOP,
        marginBottom: numberOfProperties === 0 ? LAST_SKELETON_VALUE_MARGIN_BOTTOM : 0
      }, `chiclet-skeleton-prop-primary`), Array.from({
        length: numberOfProperties
      }).map((_, _index) => /*#__PURE__*/_jsx(SkeletonValue, {
        "data-test-id": "chiclet-skeleton-value",
        width: _index % 2 ? 200 : 140,
        marginBottom: _index === numberOfProperties - 1 ? LAST_SKELETON_VALUE_MARGIN_BOTTOM : 0
      }, `chiclet-skeleton-prop-${_index}`))]
    })
  }, `chiclet-skeleton-${cardId}`);
}
function ChicletListSkeleton({
  cardId,
  numberOfSkeletons,
  numberOfProperties
}) {
  const numberOfSkeletonsNormalized = numberOfSkeletons > 5 ? 5 : numberOfSkeletons;
  const skeletons = Array.from({
    length: numberOfSkeletonsNormalized
  });
  const primaryTagSpacing = false; // Not currently used, but keeping this to match the original code in card-associated-objects-lib
  const paddingBlockStart = primaryTagSpacing ? '0' : '200'; // Keep in sync with TILE_PADDING

  return /*#__PURE__*/_jsx(List, {
    "data-loading": true,
    "data-test-id": "chiclet-list-skeleton",
    styled: false,
    role: "status",
    id: `chiclet-skeleton-list-${cardId}`,
    children: skeletons.map((__, index) => /*#__PURE__*/_jsx(Tile, {
      "data-test-id": "chiclet",
      compact: true,
      marginBlockStart: index === 0 ? '0' : '400' /* keep in sync with ITEM_MARGIN_HEIGHT */,
      marginBlockEnd: "300" // Keep in sync with TILE_MARGIN_BOTTOM
      ,
      paddingInline: "300",
      paddingBlockStart: paddingBlockStart,
      paddingBlockEnd: "200" // Keep in sync with TILE_PADDING
      ,
      children: /*#__PURE__*/_jsx(TileSection, {
        padding: "0",
        children: /*#__PURE__*/_jsx(View, {
          inlineSize: "100",
          children: /*#__PURE__*/_jsx(ChicletContentSkeleton, {
            cardId: cardId,
            numberOfProperties: numberOfProperties
          })
        })
      })
    }, `chiclet-skeleton-${index}`))
  });
}
export default ChicletListSkeleton;